module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "level-item control has-icon lxm-search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value),
      expression: "value"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm._s(_vm.value)
    },
    on: {
      "click": _vm.inputClicked,
      "keyup": function($event) {
        if (_vm._k($event.keyCode, "enter", 13)) { return; }
        _vm.submit($event)
      },
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.value = $event.target.value
      }, _vm.inputted]
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "lxm-search-icon",
    attrs: {
      "src": require("../../images/main/nav-search.png")
    },
    on: {
      "click": _vm.submit
    }
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-67b9192e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67b9192e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/common/LxmSearch.vue
// module id = 860
// module chunks = 0